import React from 'react';

const FOOD_PREFERENCE_OPTIONS = [
    { label: "Beef", description: "Steak, Burger, Roast Beef" },
    { label: "Lamb", description: "Chops, Roast Lamb, stews" },
    { label: "Game", description: "Venison, Pheasant, Rabbit" },
    { label: "Pork", description: "roast, sausages, charcuterie" },
    { label: "Poultry", description: "Chicken, Turkey, Duck" },
    { label: "Seafood", description: "Fish, Shellfish, Sushi" },
    { label: "Vegetarian", description: "Vegetable-based dishes, Salads" },
    { label: "Vegan", description: "Plant-based dishes, Salads" },
    { label: "Cheese", description: "Cheese, Soft, Hard, Blue, Aged" },
    { label: "Spicy", description: "Spice, Curry, Mexican, Thai" },
    { label: "Umami", description: "Umami, Savory, Brothy, Meaty" },
    { label: "Dessert", description: "Desserts, Sweets, Pastries" },
];

const CookingStep = ({ 
    selectedFoodPreferences,
    foodChoice,
    setFoodChoice,
    toggleFoodPreference,
    onNext,
    onBack
}) => {
    const cookingQuestion = "What are you cooking tonight?";

    return (
        <div className="step-container">
            <h2>{cookingQuestion}</h2>
            
            {/* Food Preference Buttons */}
            <div className="preference-buttons">
                {FOOD_PREFERENCE_OPTIONS.map((option) => (
                    <button
                        key={option.label}
                        type="button"
                        className={`pref-button ${(selectedFoodPreferences || []).includes(option.label) ? 'selected' : ''}`}
                        onClick={() => toggleFoodPreference(option.label)}
                        title={option.description}
                    >
                        {option.label}
                    </button>
                ))}
            </div>

            <p className="message-text">
                Or type tonight's dish below:
            </p>            

            {/* Free-form text input for food */}
            <textarea
                className="full-width-textarea"
                placeholder="Tell me more about what you're cooking..."
                value={foodChoice}
                onChange={(e) => setFoodChoice(e.target.value)}
                rows="3"
            />
            
            <div className="navigation-buttons">
                <button onClick={onBack}>Back</button>
                <button onClick={onNext}>Next</button>
            </div>
        </div>
    );
};

export default CookingStep;
